module.exports = __webpack_public_path__ + "img/cooperate_33.599b8114.png";